define(function(require) {

  const ViewManager = require('civicsUtils/view_manager');
  const general_utilities = require('civicsUtils/general_utilities');

return {
  isViewAvailable: function(activeProfiles, reportType) {
    // you can see the report if your assigned profile
    // has permission to see the report
    var canView = false;

    activeProfiles.forEach(function(activeProfile){
      if(activeProfile.name == 'Customer') {
        canView = reportType.customerView;
      } else if (activeProfile.name == 'Provider') {
        canView = reportType.providerView;
      } else if (activeProfile.name == 'Public') {
        canView = reportType.publicView;

      }
    });

    return canView;

  },
  canAddReportType: function(activeProfiles, reportData, milestoneType, applicationType) {
    var addReportType = false;
    var viewAvailable = this.isViewAvailable(activeProfiles, reportData);

    if(viewAvailable) {
      if(reportData.criteria) {
        reportData.criteria.forEach((criterion) => {
          if(criterion.applicationType && applicationType == criterion.applicationType.toLowerCase()) {
            //if milestone is blank in report criteria node, show report for all milestones
            if(criterion.milestones == null || criterion.milestones.trim() == "") {
              addReportType = true;
            } else {
              var milestones = criterion.milestones.split(',');

              var milestone = milestones.find((ms) => 
                milestoneType == ms.toLowerCase()
              );

              if(milestone != null) {
                addReportType = true;
              }
            }
          }
        });
      }

      if(reportData.criteria && reportData.criteria.length == 0) {
        addReportType = true;
      }

      if(reportData.reportName && reportData.reportName.length == 0) {
        addReportType = false;
      }

    }


    return addReportType;
  },
  getReportsData: function(reportPages, instrumentType) {
    var reportPage = null;
    var product = null;
    var reportsData = [];
    if(reportPages !=null ) {
      reportPage = reportPages.find(function(reportPage) {
        return reportPage.pageName && reportPage.pageName.toLowerCase() == 'infoviewer';
      });

      if(reportPage != null && reportPage.products != null) {
        product = reportPage.products.find(function(item) {
          return item.productName && item.productName.toLowerCase() == instrumentType;
        });
      }

      if(product != null) {
        reportsData = product.reports;
      }

    }

    return reportsData;

  },
  getReportTypes: function(mt, at, it, instrumentID, activeProfiles, modelID, useSecuredURL) {
    var milestoneType = mt ? mt.toLowerCase() : '';
    var applicationType = at ? at.toLowerCase() : '';
    var instrumentType = it ? it.toLowerCase() : '';


    //variables
    var reports = ViewManager.globalConfig().toJSON().reports;

    var reportPages = reports ? reports.reportPages : null;

    var reportTypes = [];//array of report types for download selection

    var reportsData = this.getReportsData(reportPages, instrumentType);

    reportsData.forEach((reportData) => {
      var addReportType = this.canAddReportType(activeProfiles, reportData, milestoneType, applicationType);

      if(addReportType) {
        var reportLink ;

        if (!useSecuredURL){
          reportLink = '/delegate/civics-api/api/core/reports/'+reportData.reportName+'/'+instrumentID;
        } else {
          reportLink = '/delegate/civics-api/api/cdr/applications/'+instrumentType+'/'+modelID+'/reports/'+reportData.reportName;
        }

        reportTypes.push({ //add reportType to download selection array
          link: reportLink,
          displayName: reportData.displayName,
          reportName: reportData.reportName
        });
      }
    });


    return reportTypes;

  },

  processReport: function(model) {
    // open the report, and if it has a no-output message, open a notification with the message
      this.openReport(model).then(function(val) {
        if(val) {
			general_utilities.civicsToastPop(val, "success");
        }
      });

  },
  openReport: function(model) {
    ViewManager.loading(true);

    // Create xhr request
    var xhr = new XMLHttpRequest();
    xhr.open('GET', model.get('link'), true);
    xhr.responseType = 'blob';

    var reportDone = $.Deferred();

    xhr.onload = function () {
      var blob = this.response;

      // If the status is 204 No Content we use a default run message.
      // If the response has a content type of application/json we attempt to extract the run message from the string
      if(this.status === 204 || (this.status === 200 && xhr.getResponseHeader('Content-Type') === 'application/json')) {
        const fr = new FileReader();
        var hasDefaultRunMsg = false;

        fr.onload = (e) => {
          if(e.target.result != null && e.target.result.length > 0) {
            var msg = JSON.parse(e.target.result);
            if(msg && msg.message) {
              reportDone.resolve(msg.message);
              hasDefaultRunMsg = true;
            }

          }

          if(!hasDefaultRunMsg) {
            var defaultRunMsg = i18n.t('CIVICS.INSTRUMENT_DETAIL.REPORTS.DEFAULT_RUN_MESSAGE');
            reportDone.resolve(defaultRunMsg);
          }

          ViewManager.loading(false);

        };

        fr.readAsText(blob);


      } else if (this.status === 200) {
        //if the response doesn't have an application/json content type
        // we assume that it is a report

        if(typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob);
        } else {
          var downloadUrl = "";

          if(window.webkitURL) {
            downloadUrl = window.webkitURL.createObjectURL(blob);
          } else {
            downloadUrl = window.URL.createObjectURL(blob);
          }

          var a = document.createElement("a");

          a.href = downloadUrl;
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();

          setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup

          ViewManager.loading(false);

          reportDone.resolve();
        }


      } else {
        reportDone.reject();
         ViewManager.loading(false);

         ViewManager.openAlert(i18n.t('CIVICS.INSTRUMENT_DETAIL.REPORTS.REPORT_ERROR'));
      }
    }

    xhr.send();

    return reportDone.promise();
  }
}
});
